import { ReactComponent as InfoCircleIcon } from "assets/images/iconsV2/info-circle.svg";
import Badge from "components/v2/Badge/Badge";

import "./FieldWarningBadge.scss";

interface FieldWarningBadgeProps {
  message: string;
}

export default function FieldWarningBadge({ message }: FieldWarningBadgeProps) {
  return (
    <div className="rfv2-field-warning-badge">
      <Badge
        type="category-badge"
        color="warning"
        size="sm"
        variant="icon-leading"
        icon={<InfoCircleIcon className="rfv2-field-warning-badge__icon" />}
        label={message}
      />
    </div>
  );
}
